<template>
  <base-message-box v-if="true" class="base-tip-box" :icon-class="iconClass" :type="type">
    <p class="el-message__content" v-safe-html="finalHtml"></p>
    <i v-if="false" class="el-message__closeBtn el-icon-close"></i>
  </base-message-box>
  <div v-else role="message" class="base-tip-box my-2 el-message" :class="boxClass">
    <i class="el-message__icon" :class="iconClass"></i>
    <p class="el-message__content" v-safe-html="finalHtml"></p>
    <i v-if="false" class="el-message__closeBtn el-icon-close"></i>
  </div>
</template>
<script>
import MessageType from '@/classes/enums/MessageType'
export default {
  name: 'base-tip-box',
  props: {
    textContent: {
      type: [String, Array],
      default: ''
    },
    type: {
      type: String,
      default: MessageType.INFO,
      validator: value => Object.values(MessageType).includes(value)
    },
    links: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    finalHtml: function () {
      const hasLinks = Object.keys(this.links || {}).length
      const process = (str) => {
        if (!hasLinks) return str
        return str.replace(/#LINK:(\w+)#/g, (full, key) => {
          const value = this.links[key]
          if (!value?.text && !value?.url) return full
          const text = value.text || value.url
          const url = value.url
          if (!url) return text
          return `<a class="${this.darkMode ? 'text-primary' : 'text-primary-800'}" href="${url}" target="_blank">${text}</a>`
        })
      }
      if (typeof this.textContent === 'string') {
        return `<p>${process(this.textContent)}</p>`
      }
      if (Array.isArray(this.textContent)) {
        return `<p>${this.textContent.map(String).map(process).join('</p><p>')}</p>`
      }
      return `<p>${process(String(this.textContent))}</p>`
    },
    finalType: function () {
      switch (this.type) {
        case MessageType.SUCCESS:
        case MessageType.WARNING:
        case MessageType.ERROR:
        case MessageType.INFO:
          return this.type
        default:
          return MessageType.INFO
      }
    },
    boxClass: function () {
      return `el-message--${this.finalType}`
    },
    iconClass: function () {
      return `el-icon-${this.finalType}`
    }
  },
}
</script>

<style scoped>
.el-message {
  position: relative;
  transform: none;
  left: auto;
  top: auto;
  transition: none;
  z-index: inherit !important;
}
</style>
